import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

function checkRules(to, from, next) {
  if (!localStorage.getItem('token')) goToAuthRoute(to, from, next)
  const user = store.getters.user
  if (!user) {
    store.dispatch('GET_PERMISSIONS_FOR_USER').then(() => {
      checkPermission(to, from, next, store.getters.user)
    })
  } else {
    checkPermission(to, from, next, user)
  }
  // хз что это
  // TODO: Move this code to global routing handler
  store.commit('setOverlay', false)
}

function checkPermission(to, from, next, user) {
  if (user.is_superuser) {
    next()
    return
  }

  if (to.meta.permission) {
    if (store.getters.userSelfPermissions.includes(to.meta.permission)) {
      next()
      return
    } else {
      if (
        to.name === 'dashboard' &&
        store.getters.userSelfPermissions.includes(Vue.config.permissions.PERMISSIONS_CONSTANTS.CALENDAR)
      ) {
        next({ name: 'index' })
        return
      }

      if (
        _.some(to.matched, route => {
          return route.name === 'index' || route.name === 'dashboard'
        })
      ) {
        next({ name: 'employers' })
        return
      } else {
        goToAuthRoute(to, from, next)
        return
      }
    }
  }

  next()
}

function goToAuthRoute(to, from, next) {
  next({
    path: Vue.config.modules.crm.route.auth,
    query: { redirect: to.fullPath },
  })
}

const BlankLayout = () => import('@/layouts/Blank/Blank')

export default new VueRouter({
  routes: [
    {
      path: '/buyCertificate',
      component: () => import('@/pages/Finance/Certificate/BuyCertificate/BuyCertificate'),
      name: 'buyCertificate',
      meta: {
        permission: '',
        layout: BlankLayout,
      },
    },
    {
      path: '/qrscan',
      component: () => import('@/pages/QrScan/QrScan'),
      name: 'qrScan',
      meta: {
        permission: '',
        layout: BlankLayout,
      },
    },
    {
      path: '/generalQr',
      component: () => import('@/pages/GeneralQr/GeneralQr'),
      name: 'generalQr',
      meta: {
        permission: '',
        layout: BlankLayout,
      },
    },
    {
      path: '/form-booking-from-site',
      component: () => import('@/pages/FormBookingFromSite/FormBookingFromSite'),
      name: 'form-booking-from-site',
    },
    {
      path: '/shedule_wishes',
      component: () => import('@/pages/AutoSchedule/ScheduleWishes'),
      name: 'sheduleWishes',
      beforeEnter: checkRules,
      meta: {
        permission: '',
      },
    },
    {
      path: '/statistics',
      component: () => import('@/pages/AutoSchedule/Statistics'),
      name: 'statistics',
      beforeEnter: checkRules,
      meta: {
        permission: '',
      },
    },
    {
      path: '/forecasting',
      component: () => import('@/pages/AutoSchedule/Forecasting'),
      name: 'forecasting',
      beforeEnter: checkRules,
      meta: {
        permission: '',
      },
    },
    {
      path: '/masterPage',
      component: () => import('@/pages/AutoSchedule/MasterPage'),
      name: 'masterPage',
      beforeEnter: checkRules,
      meta: {
        permission: '',
      },
    },
    {
      path: '/events',
      component: () => import('@/pages/AutoSchedule/Events'),
      name: 'events',
      beforeEnter: checkRules,
      meta: {
        permission: '',
      },
    },
    {
      path: '/mastersTable',
      component: () => import('@/pages/AutoSchedule/MastersTable'),
      name: 'mastersTable',
      beforeEnter: checkRules,
      meta: {
        permission: '',
      },
    },
    {
      path: '/r/:hash',
      component: () => import('@/pages/Review/ReviewPage'),
      name: 'review',
    },
    {
      path: '/',
      component: () => import('@/pages/DashboardNew/DashboardNew'),
      name: 'dashboard',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.DASHBOARD,
      },
    },
    {
      path: '/calendar',
      component: () => import('@/pages/Calendar/Calendar'),
      name: 'index',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.CALENDAR,
      },
    },
    {
      path: '/auth',
      component: () => import('@/pages/Auth/Auth'),
      name: 'auth',
    },
    {
      path: '/email_confirmation/:token',
      component: () => import('@/pages/EmailConfirmation/EmailConfirmation'),
      name: 'email_confirmation',
      props: route => {
        return {
          token: route.params.token,
        }
      },
    },
    {
      path: '/calendar',
      component: () => import('@/pages/Calendar/Calendar'),
      name: 'calendar',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.CALENDAR,
      },
    },
    {
      path: '/customers',
      component: () => import('@/pages/Customers/CustomersList/CustomersList'),
      name: 'customers',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.CUSTOMERS,
      },
    },
    {
      path: '/app-reviews',
      component: () => import('@/pages/AppReview/AppReviewList'),
      name: 'appReviews',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.CUSTOMERS,
      },
    },
    {
      path: '/customers/new',
      component: () => import('@/pages/Customers/CustomerViewNew/CustomerViewNew'),
      name: 'newCustomer',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.NEW_CUSTOMER,
      },
    },
    {
      path: '/customers/segments',
      component: () => import('@/pages/Customers/views/SegmentsTab.vue'),
      name: 'customersSegments',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.CUSTOMERS,
      },
    },
    {
      path: '/promotions',
      component: () => import('@/pages/Promotions/Promotions'),
      name: 'promotions',
      beforeEnter: checkRules,
      // meta: {
      //   permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.NEW_CUSTOMER
      // }
    },
    {
      path: '/customers/:id',
      component: () => import('@/pages/Customers/CustomerView/CustomerView'),
      name: 'customer',
      props: route => {
        return {
          id: Number(route.params.id),
        }
      },
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.CUSTOMER,
      },
    },
    {
      path: '/bookings',
      component: () => import('@/pages/Bookings/BookingsList/Bookings'),
      name: 'bookings',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.BOOKINGS,
      },
    },
    {
      path: '/bookings/new-old',
      component: () => import('@/pages/BookingNew/BookingNew'),
      name: 'newBookingOld',
      beforeEnter: checkRules,
      props: route => {
        return {
          fromBooking: route.params.fromBooking,
        }
      },
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.NEW_BOOKING,
      },
    },
    {
      path: '/bookings/new',
      component: () => import('@/pages/BookingNewNew/BookingNew'),
      name: 'newBooking',
      beforeEnter: checkRules,
      props: route => {
        return {
          fromBooking: route.params.fromBooking,
        }
      },
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.NEW_BOOKING,
      },
    },
    {
      path: '/bookings/:id',
      component: () => import('@/pages/BookingView/BookingView'),
      name: 'booking',
      props: route => {
        return {
          id: route.params.id,
        }
      },
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.BOOKING,
      },
    },
    {
      path: '/waiting-list',
      component: () => import('@/pages/WaitingList/WaitingList'),
      name: 'waitingList',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.WAITING_LIST,
      },
    },
    {
      path: '/employers',
      component: () => import('@/pages/Employers/Employers'),
      name: 'employers',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.EMPLOYEES,
      },
    },
    {
      path: '/registration-employers',
      component: () => import('@/pages/RegistrationEmployers/EmployersList'),
      name: 'registration-employers',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.EMPLOYEES,
      },
    },
    {
      path: '/segments',
      component: () => import('@/pages/Segments/SegmentsList'),
      name: 'segments',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.EMPLOYEES,
      },
    },
    {
      path: '/segments/clients-of-segment/:segmentId',
      component: () => import('@/pages/Segments/ClientsOfSegment'),
      name: 'clients-of-segment',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.EMPLOYEES,
      },
    },
    {
      path: '/bonus-system',
      component: () => import('@/pages/BonusSystem/BonusSystemList'),
      name: 'bonus-system',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.EMPLOYEES,
      },
    },
    {
      path: '/club-cards',
      component: () => import('@/pages/ClubCards/ClubCardsPage'),
      name: 'club-cards',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.EMPLOYEES,
      },
    },
    {
      path: '/registration-employer/:id',
      component: () => import('@/pages/RegistrationEmployers/Employer'),
      name: 'registration-employer-item',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.EMPLOYEES,
      },
    },
    // {
    //   path: '/employers/new',
    //   component: () => import('@/pages/EmployerViewNew/EmployerViewNew'),
    //   name: 'newEmployer',
    //   beforeEnter: checkRules,
    //   meta: {
    //     permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.NEW_EMPLOYEE
    //   }
    // },
    {
      path: '/employers/new',
      component: () => import('@/pages/EmployerView/EmployerViewWrapper'),
      name: 'newEmployer',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.EMPLOYEE,
      },
    },
    {
      path: '/employers/:id',
      component: () => import('@/pages/EmployerView/EmployerViewWrapper'),
      name: 'employer',
      props: route => {
        return {
          id: route.params.id,
        }
      },
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.EMPLOYEE,
      },
    },
    // {
    //   path: '/employers/:id',
    //   component: () => import('@/pages/EmployerViewOld/EmployerView'),
    //   name: 'employer',
    //   props: (route) => {
    //     return {
    //       id: route.params.id
    //     };
    //   },
    //   beforeEnter: checkRules,
    //   meta: {
    //     permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.EMPLOYEE
    //   }
    // },
    {
      path: '/candidates',
      component: () => import('@/pages/Candidates/Candidates'),
      name: 'candidates',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.CANDIDATES,
      },
    },
    {
      path: '/services',
      component: () => import('@/pages/Services/Services'),
      name: 'services',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.SERVICES,
      },
    },
    {
      path: '/partners',
      component: () => import('@/pages/Partners/PartnersList'),
      name: 'partners',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.SERVICES,
      },
    },
    {
      path: '/call-center-workplace',
      component: () => import('@/pages/CallCenter/WorkPlacesList'),
      name: 'call-center-workplace',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.CALL_CENTER_WORKPLACE.view,
      },
    },
    {
      path: '/partners-view/:id',
      component: () => import('@/pages/Partners/PartnerView'),
      name: 'partners-view',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.SERVICES,
      },
    },
    {
      path: '/services/new',
      component: () => import('@/pages/ServiceViewNew/ServiceViewNew'),
      name: 'serviceNew',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.NEW_SERVICES,
      },
    },
    {
      path: '/services/category/new',
      component: () => import('@/pages/ServiceCategoryViewNew/ServiceCategoryViewNew'),
      name: 'serviceCategoryNew',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.NEW_SERVICE_CATEGORY,
      },
    },
    {
      path: '/services/category/:id',
      component: () => import('@/pages/ServiceCategoryView/ServiceCategoryView'),
      name: 'serviceCategory',
      props: route => {
        return {
          id: route.params.id,
        }
      },
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.SERVICE_CATEGORY,
      },
    },
    {
      path: '/services/:id',
      component: () => import('@/pages/ServiceView/ServiceView'),
      name: 'serviceView',
      props: route => {
        return {
          id: route.params.id,
        }
      },
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.SERVICE,
      },
    },
    {
      path: '/service_templates',
      component: () => import('@/pages/Services/ServiceTemplates/ServiceTemplates'),
      name: 'serviceTemplates',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.SERVICE_TEMPLATES,
      },
    },
    {
      path: '/service_templates/new',
      component: () => import('@/pages/ServiceTemplatesViewNew/ServiceTemplatesViewNew'),
      name: 'serviceTemplatesViewNew',
      props: route => {
        return {
          id: route.params.id,
        }
      },
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.SERVICE_TEMPLATES,
      },
    },
    {
      path: '/service_templates/:id',
      component: () => import('@/pages/ServiceTemplatesView/ServiceTemplatesView'),
      name: 'serviceTemplatesView',
      props: route => {
        return {
          id: route.params.id,
        }
      },
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.SERVICE_TEMPLATES,
      },
    },
    // {
    //   path: '/work_positions',
    //   component: () => import('@/pages/WorkPositions/WorkPositions'),
    //   name: 'workPositions',
    //   beforeEnter: checkRules,
    //   meta: {
    //     permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.WORK_POSITIONS_VIEW
    //   }
    // },
    {
      path: '/positions_and_access',
      component: () => import('@/pages/WorkPositions/PositionsAndAccess'),
      name: 'positionAndAccess',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.WORK_POSITIONS_VIEW,
      },
    },
    {
      path: '/work_positions/new',
      component: () => import('@/pages/WorkPositionViewNew/WorkPositionViewNew'),
      name: 'workPositionNew',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.WORK_POSITIONS_UPDATE,
      },
    },
    {
      path: '/work_positions/:id',
      component: () => import('@/pages/WorkPositionView/WorkPositionView'),
      name: 'workPositionView',
      props: route => {
        return {
          id: route.params.id,
        }
      },
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.WORK_POSITIONS_VIEW,
      },
    },
    {
      path: '/units',
      component: () => import('@/pages/Units/Units'),
      name: 'units',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.UNITS_VIEW,
      },
    },
    {
      path: '/units/new',
      component: () => import('@/pages/UnitViewNew/UnitViewNew'),
      name: 'newUnit',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.UNITS_CREATE,
      },
    },
    {
      path: '/units/:id',
      component: () => import('@/pages/UnitView/UnitView'),
      name: 'unitView',
      props: route => {
        return {
          id: route.params.id,
        }
      },
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.UNITS_VIEW,
      },
    },
    {
      path: '/revenue-plan',
      component: () => import('@/pages/UnitRevenuePlans/UnitRevenuePlans'),
      name: 'unitRevenuePlans',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.REVENUE_PLANS.view,
      },
    },
    {
      path: '/work_places_intervals',
      component: () => import('@/pages/WorkPlacesIntervals/WorkPlacesIntervals'),
      name: 'workPlacesIntervals',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.WORK_PLACES_INTERVALS,
      },
    },
    {
      path: '/logs',
      component: () => import('@/pages/Logs/Logs'),
      name: 'logs',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.LOGS,
      },
    },
    {
      path: '/widget-settings',
      component: () => import('@/pages/Widget/Cities'),
      name: 'widget-settings',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.LOGS,
      },
    },
    {
      path: '/schedule',
      component: () => import('@/pages/Schedule/Schedule'),
      name: 'Schedule',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.SCHEDULE,
      },
    },
    {
      path: '/attendance',
      component: () => import('@/pages/Attendance/Attendance'),
      name: 'Attendance',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.SCHEDULE,
        // permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.LIST_ACTIVE_FINGERPRINT
      },
    },
    {
      path: '/photo-works',
      component: () => import('@/pages/Photoworks/Photoworks'),
      name: 'Photoworks',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.PHOTO_WORK,
      },
    },
    {
      path: '/active_list_fingerprint',
      component: () => import('@/pages/ActiveListFingerprint/ActiveListFingerprint'),
      name: 'listActiveFingerprint',
      beforeEnter: checkRules,
      // meta: {
      //   permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.LIST_ACTIVE_FINGERPRINT
      // }
    },
    {
      path: '/chat',
      component: () => import('@/pages/Chat/Chat'),
      name: 'chat',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.CHAT,
      },
    },
    {
      path: '/telephony',
      component: () => import('@/pages/Telephony/Telephony'),
      name: 'telephonyOptions',
      props: route => {
        return {
          alias: route.params.alias,
        }
      },
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.TELEPHONY,
      },
    },
    {
      path: '/analytics',
      component: () => import('@/pages/Analytics/Analytics'),
      name: 'analytics',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.ANALYTICS,
      },
    },
    {
      path: '/analytics/new',
      component: () => import('@/pages/AnalyticsViewNew/AnalyticsViewNew'),
      name: 'analyticsViewNew',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.NEW_ANALYTICS,
      },
    },
    {
      path: '/analytics/fill-studios',
      component: () => import('@/pages/AnalyticsFillStudios/AnalyticsFillStudios'),
      name: 'analyticsFillStudios',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.ANALYTICS,
      },
    },
    {
      path: '/analytics/:id',
      component: () => import('@/pages/AnalyticsView/AnalyticsView'),
      name: 'analyticsView',
      props: route => {
        return {
          id: route.params.id,
        }
      },
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.ANALYTICS,
      },
    },
    {
      path: '/analytics-tablets',
      component: () => import('@/pages/AnalyticsTablets/AnalyticsTablets'),
      name: 'analytics-tablets',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.ANALYTICS,
      },
    },
    {
      path: '/tablets',
      component: () => import('@/pages/Tablets/TabletsView'),
      name: 'tablets',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.ANALYTICS,
      },
    },
    {
      path: '/varnishes',
      component: () => import('@/pages/Preferences/Varnishes'),
      name: 'varnishes',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.ANALYTICS,
      },
    },
    {
      path: '/call_center',
      component: () => import('@/pages/CallCenter/CallCenter'),
      name: 'callCenter',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.CALL_CENTER,
      },
    },
    {
      path: '/storage',
      component: () => import('@/pages/Storage/Storage'),
      name: 'storage',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.STORAGE,
      },
    },
    {
      path: '/pilki_school',
      component: () => import('@/pages/PilkiSchool/PilkiSchool'),
      name: 'pilkiSchool',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.SCHOOL,
      },
    },
    {
      path: '/PG-0',
      component: () => import('@/pages/Easteregg/PG0'),
      name: 'PG0',
      beforeEnter: checkRules,
    },
    {
      path: '/affiliates',
      component: () => import('@/pages/Affiliates/Affiliates'),
      name: 'affiliates',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.AFFILIATES,
      },
    },
    {
      path: '/settings/account',
      component: () => import('@/pages/SettingsAccount/SettingsAccount'),
      name: 'settingsAccount',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.ACCOUNT_SETTINGS,
      },
    },
    {
      path: '/settings/system/:id',
      component: () => import('@/pages/SettingsSystem/SettingsSystem'),
      name: 'settingsSystem',
      props: route => {
        return {
          id: route.params.id,
        }
      },
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.SYSTEM_SETTINGS,
      },
    },
    {
      path: '/settings/company/:id',
      component: () => import('@/pages/SettingsCompany/SettingsCompany'),
      name: 'settingsCompany',
      props: route => {
        return {
          id: route.params.id,
        }
      },
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.COMPANY_SETTINGS,
      },
    },
    {
      path: '/geography/settings-location',
      component: () => import('@/pages/Geography/SettingsLocation'),
      name: 'SettingsLocation',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.SUPER_ADMIN_PERMISSIONS,
      },
    },
    {
      path: '/tickets',
      component: () => import('@/pages/CommunicationsCenter/Tickets/TicketList/AllTickets'),
      name: 'tickets',
      beforeEnter: checkRules,
    },
    {
      path: '/tickets/new',
      component: () => import('@/pages/CommunicationsCenter/Tickets/AddTicket/AddTicket'),
      name: 'ticketsNew',
      beforeEnter: checkRules,
    },
    // {
    //   path: '/tickets/unapproved',
    //   component: () => import('@/pages/CommunicationsCenter/Tickets/TicketList/UnapprovedTickets'),
    //   name: 'unapprovedTickets',
    //   beforeEnter: checkRules,
    // },
    {
      path: '/tickets/groups',
      component: () => import('@/pages/CommunicationsCenter/TicketsGroups/TicketsGroups'),
      name: 'ticketsGroups',
      beforeEnter: checkRules,
    },
    {
      path: '/tickets/groups/new',
      component: () => import('@/pages/CommunicationsCenter/TicketsGroups/TicketsGroupsNew'),
      name: 'ticketsGroupsNew',
      beforeEnter: checkRules,
    },
    {
      path: '/tickets/groups/:id',
      component: () => import('@/pages/CommunicationsCenter/TicketsGroups/TicketsGroupsView'),
      name: 'ticketsGroupsView',
      beforeEnter: checkRules,
    },
    {
      path: '/tickets/:id',
      component: () => import('@/pages/CommunicationsCenter/Tickets/Ticket/Ticket'),
      name: 'ticket',
      beforeEnter: checkRules,
    },
    {
      path: '/crm-instruction',
      component: () => import('@/pages/CRMInstruction/CRMInstruction'),
      name: 'crm-instruction',
      beforeEnter: checkRules,
    },
    {
      path: '/crm-faq',
      component: () => import('@/pages/CRMFAQ/CRMFAQ'),
      name: 'crm-faq',
      beforeEnter: checkRules,
    },
    {
      path: '/crm-instruction',
      component: () => import('@/pages/Request/Request'),
      name: 'request',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.REQUEST,
      },
    },
    {
      path: '/goods',
      component: () => import('@/pages/Goods/Goods'),
      name: 'goods',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.GOODS,
      },
    },
    {
      path: '/goods/new',
      component: () => import('@/pages/Goods/GoodViewNew'),
      name: 'newGood',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.NEW_PRODUCT,
      },
    },
    {
      path: '/good_groups',
      component: () => import('@/pages/GoodGroups/GoodGroups'),
      name: 'goodGroups',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.PRODUCTS_GROUPS,
      },
    },
    {
      path: '/good_groups/new',
      component: () => import('@/pages/GoodGroups/GoodGroupNew'),
      name: 'goodGroupNew',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.PRODUCTS_GROUPS,
      },
    },
    {
      path: '/good_groups/:id',
      component: () => import('@/pages/GoodGroups/GoodGroupView'),
      name: 'goodGroup',
      props: route => {
        return {
          id: route.params.id,
        }
      },
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.PRODUCTS_GROUPS,
      },
    },
    {
      path: '/goods/:goodID',
      component: () => import('@/pages/Goods/GoodView'),
      name: 'good',
      props: route => {
        return {
          id: route.params.goodID,
        }
      },
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.PRODUCT,
      },
    },
    {
      path: '/good-flows',
      component: () => import('@/pages/GoodFlows/GoodFlows'),
      name: 'goodFlows',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.PRODUCTS_FLOW,
      },
    },
    {
      path: '/good-flows/new',
      component: () => import('@/pages/GoodFlows/GoodFlowNew'),
      name: 'goodFlowNew',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.NEW_PRODUCT_FLOW,
      },
    },
    {
      path: '/good-flows/:itemId',
      component: () => import('@/pages/GoodFlows/GoodFlowView'),
      name: 'goodFlowView',
      props: route => {
        return {
          itemId: Number(route.params.itemId),
        }
      },
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.PRODUCT_FLOW,
      },
    },
    {
      path: '/good-remains',
      component: () => import('@/pages/GoodRemains/GoodRemains'),
      name: 'goodRemains',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.PRODUCTS_REMAINS,
      },
    },
    {
      path: '/good-remains/:itemId',
      component: () => import('@/pages/GoodRemains/GoodRemainView'),
      name: 'goodRemainView',
      props: route => {
        return {
          id: Number(route.params.itemId),
        }
      },
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.PRODUCTS_REMAIN,
      },
    },
    {
      path: '/good-gives',
      component: () => import('@/pages/GoodGives/GoodGives'),
      name: 'goodGives',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.PRODUCTS_USAGE,
      },
    },
    {
      path: '/good-gives/:itemId',
      component: () => import('@/pages/GoodGives/GoodGiveView'),
      name: 'goodGiveView',
      props: route => {
        return {
          id: Number(route.params.itemId),
        }
      },
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.PRODUCTS_USAGE,
      },
    },
    {
      path: '/good-invoices',
      component: () => import('@/pages/GoodInvoices/GoodInvoices'),
      name: 'goodInvoices',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.PRODUCT_INVOICES,
      },
    },
    {
      path: '/good-invoices/:itemId',
      component: () => import('@/pages/GoodInvoices/GoodInvoiceView'),
      name: 'goodInvoiceView',
      props: route => {
        return {
          id: Number(route.params.itemId),
        }
      },
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.PRODUCT_INVOICE,
      },
    },
    {
      path: '/good-invents',
      component: () => import('@/pages/GoodInvents/GoodInvents'),
      name: 'goodInvents',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.PRODUCT_INVENTS,
      },
    },
    {
      path: '/good-invents/new',
      component: () => import('@/pages/GoodInvents/GoodInventNew'),
      name: 'goodInventNew',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.NEW_PRODUCT_INVENT,
      },
    },
    {
      path: '/good-invents/:itemId',
      component: () => import('@/pages/GoodInvents/GoodInventView'),
      name: 'goodInventView',
      props: route => {
        return {
          itemId: Number(route.params.itemId),
        }
      },
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.PRODUCT_INVENT,
      },
    },
    {
      path: '/good-orders',
      component: () => import('@/pages/GoodOrders/GoodOrders'),
      name: 'goodOrders',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.PRODUCT_ORDERS,
      },
    },
    {
      path: '/good-orders/:itemId',
      component: () => import('@/pages/GoodOrders/GoodOrderView'),
      name: 'goodOrderView',
      props: route => {
        return {
          id: route.params.itemId,
        }
      },
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.PRODUCT_ORDER,
      },
    },
    {
      path: '/good-orders/new',
      component: () => import('@/pages/GoodOrders/GoodOrderNew'),
      name: 'goodOrderNew',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.NEW_PRODUCT_ORDER,
      },
    },
    {
      path: '/goods-standard',
      component: () => import('@/pages/GoodsStandard/GoodsStandard'),
      name: 'goodsStandard',
      beforeEnter: checkRules,
    },
    {
      path: '/equipment-types',
      component: () => import('@/pages/EquipmentTypes/EquipmentTypes'),
      name: 'equipmentTypes',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.EQUIPMENT_TYPES,
      },
    },
    {
      path: '/equipment-types/new',
      component: () => import('@/pages/EquipmentTypes/EquipmentTypeNew'),
      name: 'equipmentTypeNew',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.NEW_EQUIPMENT_TYPE,
      },
    },
    {
      path: '/equipment-types/:itemId',
      component: () => import('@/pages/EquipmentTypes/EquipmentTypeView'),
      name: 'equipmentTypeView',
      props: route => {
        return {
          itemId: route.params.itemId,
        }
      },
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.EQUIPMENT_TYPE,
      },
    },
    {
      path: '/finance/payment-requests',
      component: () => import('@/pages/Finance/PaymentRequests/PaymentRequests'),
      name: 'finance-payment-requests',
      beforeEnter: checkRules,
      meta: {
        permission: '', // Vue.config.permissions.PERMISSIONS_CONSTANTS.RKO,
      },
    },
    {
      path: '/finance/rko',
      component: () => import('@/pages/Finance/RKO/RKO'),
      name: 'finance-rko',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.RKO,
      },
    },
    {
      path: '/finance/rko/new',
      component: () => import('@/pages/Finance/RKO/RKOViewNew'),
      name: 'finance-rko-view-new',
      beforeEnter: checkRules,
    },
    {
      path: '/finance/rko/:orderId',
      component: () => import('@/pages/Finance/RKO/RKOView'),
      name: 'finance-rko-view',
      props: route => {
        return {
          orderId: Number(route.params.orderId),
        }
      },
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.RKO,
      },
    },
    {
      path: '/finance/pko',
      component: () => import('@/pages/Finance/PKO'),
      name: 'finance-pko',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.PKO,
      },
    },
    {
      path: '/finance/pko/new',
      component: () => import('@/pages/Finance/PKOViewNew'),
      name: 'finance-pko-view-new',
      beforeEnter: checkRules,
    },
    {
      path: '/finance/pko/:orderId',
      component: () => import('@/pages/Finance/PKOView'),
      name: 'finance-pko-view',
      props: route => {
        return {
          orderId: Number(route.params.orderId),
        }
      },
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.PKO,
      },
    },
    {
      path: '/finance/zp',
      component: () => import('@/pages/Finance/Salary/ZP'),
      name: 'finance-zp',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.ZP,
      },
    },
    {
      path: '/finance/zp/:id',
      component: () => import('@/pages/Finance/Salary/ZPView'),
      name: 'finance-zp-view',
      props: route => {
        return {
          id: Number(route.params.id),
        }
      },
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.ZP,
      },
    },
    {
      path: '/finance/report/payrollsheet/salaryId:salaryId&employerId:employerId&beginAt:beginAt&endAt:endAt',
      component: () => import('@/components/ZP/PayrollSheetView'),
      name: 'payroll-sheet-report',
      props: route => {
        return {
          salaryId: Number(route.params.salaryId),
          employerId: Number(route.params.employerId),
          beginAt: Number(route.params.beginAt),
          endAt: Number(route.params.endAt),
        }
      },
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.ZP,
      },
    },
    {
      path: '/finance/report/wageforecast/salaryId:salaryId&employerId:employerId&beginAt:beginAt&endAt:endAt',
      component: () => import('@/components/ZP/WageForecast'),
      name: 'wage-forecast',
      props: route => {
        return {
          salaryId: Number(route.params.salaryId),
          employerId: Number(route.params.employerId),
          beginAt: Number(route.params.beginAt),
          endAt: Number(route.params.endAt),
        }
      },
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.ZP,
      },
    },
    {
      path: '/finance/certificate',
      component: () => import('@/pages/Finance/Certificate/Certificate'),
      name: 'certificate',
      beforeEnter: checkRules,
      // meta: {
      //   permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.CERTIFICATE
      // }
    },
    {
      path: '/finance/exchange',
      component: () => import('@/pages/Finance/Exchange/Exchange'),
      name: 'exchange',
      beforeEnter: checkRules,
    },
    {
      path: '/finance/certificates-invent',
      component: () => import('@/pages/Finance/CertificatesInvent/CertificatesInvent'),
      name: 'certificates-invent',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.CERTIFICATE_VIEW,
      },
    },
    {
      path: '/finance/settlement-sheet',
      component: () => import('@/pages/Finance/Salary/SettlementSheet'),
      name: 'settlement-sheet',
      beforeEnter: checkRules,
    },
    {
      path: '/finance/settlement-sheet/:id',
      component: () => import('@/pages/Finance/Salary/SettlementSheetView'),
      name: 'settlement-sheet-view',
      beforeEnter: checkRules,
    },
    {
      path: '/finance/order',
      component: () => import('@/pages/Finance/Orders/Orders'),
      name: 'finance-order',
      beforeEnter: checkRules,
    },
    {
      path: '/certificates-logs',
      component: () => import('@/pages/Finance/Certificates/List'),
      name: 'certificates-logs',
      beforeEnter: checkRules,
    },
    {
      path: '/finance/order/new',
      component: () => import('@/pages/Finance/Orders/OrdersNew'),
      name: 'finance-order-new',
      beforeEnter: checkRules,
    },
    {
      path: '/finance/order/new/:bookingId',
      component: () => import('@/pages/Finance/Orders/OrdersNew'),
      name: 'finance-order-new-by-booking',
      props: route => {
        return {
          bookingId: Number(route.params.bookingId),
        }
      },
      beforeEnter: checkRules,
    },
    {
      path: '/finance/order/:orderId',
      component: () => import('@/pages/Finance/Orders/OrdersView'),
      name: 'finance-order-view',
      props: route => {
        return {
          orderId: Number(route.params.orderId),
        }
      },
      beforeEnter: checkRules,
    },
    {
      path: '/sms',
      component: () => import('@/pages/SMSHistory/SMSHistory'),
      name: 'smsHistory',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.SMS_HISTORY,
      },
    },
    {
      path: '/feedbacks',
      component: () => import('@/pages/Feedbacks/FeedbackList/Feedbacks'),
      name: 'feedbacks',
      beforeEnter: checkRules,
    },
    {
      path: '/claims',
      component: () => import('@/pages/Claims/Claims'),
      name: 'claims',
      beforeEnter: checkRules,
    },
    {
      path: '/alterations',
      component: () => import('@/pages/Alterations/Alterations'),
      name: 'alterations',
      beforeEnter: checkRules,
    },
    {
      path: '/notifications',
      component: () => import('@/pages/CommunicationsCenter/Notifications/NotificationPage'),
      name: 'notification',
      beforeEnter: checkRules,
    },
    {
      path: '/notifications/new',
      component: () => import('@/pages/CommunicationsCenter/Notifications/Notification/AddNotification'),
      name: 'addNotification',
      beforeEnter: checkRules,
    },
    {
      path: '/reviews-main',
      component: () => import('@/pages/Reviews/Reviews'),
      name: 'reviewsMain',
      beforeEnter: checkRules,
    },
    {
      path: '/feedbacks/new',
      component: () => import('@/pages/Feedbacks/FeedbackViewNew/FeedbackViewNew'),
      name: 'newFeedbackView',
      beforeEnter: checkRules,
    },
    {
      path: '/feedbacks/:id',
      component: () => import('@/pages/Feedbacks/FeedbackView/FeedbackView'),
      name: 'feedbackView',
      props: route => {
        return {
          id: route.params.id,
        }
      },
      beforeEnter: checkRules,
    },
    {
      path: '/new-employers',
      component: () => import('@/pages/NewEmployers/NewEmployers'),
      name: 'newEmployers',
      beforeEnter: checkRules,
    },
    {
      path: '/contractors',
      component: () => import('@/pages/Contractors/Contractors'),
      name: 'contractors',
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.CONTRACTORS,
      },
      beforeEnter: checkRules,
    },
    {
      path: '/contractors/:id',
      component: () => import('@/pages/ContractorView/ContractorView'),
      name: 'contractorView',
      props: route => {
        return {
          id: route.params.id,
        }
      },
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.CONTRACTORS,
      },
      beforeEnter: checkRules,
    },
    {
      path: '/contractors/new',
      component: () => import('@/pages/ContractorViewNew/ContractorViewNew'),
      name: 'contractorViewNew',
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.CONTRACTORS_ADD,
      },
      beforeEnter: checkRules,
    },
    {
      path: '/companies/',
      component: () => import('@/pages/Settings/Companies/CompaniesAndBrands/CompaniesAndBrands'),
      name: 'companies',
      beforeEnter: checkRules,
    },
    {
      path: '/companies/:id',
      component: () => import('@/pages/Settings/Companies/CompanyView/CompanyView'),
      name: 'companyView',
      beforeEnter: checkRules,
    },
    {
      path: '/companies/new',
      component: () => import('@/pages/Settings/Companies/CompanyViewNew/CompanyViewNew'),
      name: 'companyViewNew',
      beforeEnter: checkRules,
    },
    {
      path: '/copy-company/:id',
      component: () => import('@/pages/Settings/Companies/CompanyCopy/CompanyCopyView'),
      name: 'copy-company',
      beforeEnter: checkRules,
    },
    {
      path: '/copy-templates/:id',
      component: () => import('@/pages/Settings/Companies/CompanyCopy/CopyTemplates'),
      name: 'copy-templates',
      beforeEnter: checkRules,
    },
    {
      path: '/sales',
      component: () => import('@/pages/Sales/Sales'),
      name: 'sales',
      beforeEnter: checkRules,
    },
    {
      path: '/notify/templates',
      component: () => import('@/pages/Notify/NotifyTemplates'),
      name: 'notify-templates',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.NOTIFY,
      },
    },
    {
      path: '/notify/add-template',
      component: () => import('@/pages/Notify/NotifyAddTemplate'),
      name: 'notify-add-template',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.NOTIFY,
      },
    },
    {
      path: '/notify/template/:alias',
      component: () => import('@/pages/Notify/NotifyTemplateView'),
      name: 'notify-template-view',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.NOTIFY,
      },
      props: route => ({ propAlias: route.params.alias }),
    },
    {
      path: '/notify/log',
      component: () => import('@/pages/Notify/NotifyLogWrapper'),
      name: 'notify-log',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.NOTIFY,
      },
    },
    {
      path: '/notify/send',
      component: () => import('@/pages/Notify/NotifySend'),
      name: 'notify-send',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.NOTIFY,
      },
      props: route => ({ id: +route.params.id }),
    },
    {
      path: '/notify/schedules-plan',
      component: () => import('@/pages/Notify/NotifySchedulesPlan'),
      name: 'notify-schedules-plan',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.CONTRACTORS_ADD,
      },
    },
    {
      path: '/club-card-types',
      component: () => import('@/pages/ClubCardTypes/ClubCardTypes.vue'),
      name: 'club-card-types',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.CLUB_CARD_TYPES.view,
      },
    },
    {
      path: '/club-card-types/new',
      component: () => import('@/features/club-cards/AddClubCardTypeForm.vue'),
      name: 'add-club-card-type',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.CLUB_CARD_TYPES.create,
      },
    },
    {
      path: '/club-card-types/:id',
      component: () => import('@/pages/ClubCardTypes/EditClubCardType.vue'),
      name: 'edit-club-card-type',
      beforeEnter: checkRules,
    },

    {
      path: '/client-calls',
      component: () => import('@/pages/CallClients/CallList.vue'),
      name: 'client-calls',
      beforeEnter: checkRules,
    },

    {
      path: '/vouchers',
      component: () => import('@/pages/Vouchers/Index'),
      name: 'vouchers',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.VOUCHERS.view,
      },
    },
    {
      path: '/vouchers-by-promo/:id',
      component: () => import('@/pages/Vouchers/vouchersByPromo'),
      name: 'vouchers-by-promo',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.VOUCHERS.view,
      },
    },
    {
      path: '/client-app-banners/:id',
      component: () => import('@/pages/ClientApp/Banners/Item'),
      name: 'client-app_banner-item',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.BANNERS,
      },
    },
    {
      path: '/client-app-banners',
      component: () => import('@/pages/ClientApp/Banners/List'),
      name: 'client-app_banners',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.BANNERS,
      },
    },
    {
      path: '/site-banners',
      component: () => import('@/pages/Site/Banners/List'),
      name: 'site-banners',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.BANNERS,
      },
    },
    {
      path: '/site-banners/:id',
      component: () => import('@/pages/Site/Banners/Item'),
      name: 'site-banner-item',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.BANNERS,
      },
    },
    {
      path: '/client-app-nail-designs',
      component: () => import('@/pages/ClientApp/NailDesigns/List'),
      name: 'client-app_nail-designs',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.NAIL_DESIGNS,
      },
    },
    {
      path: '/client-app-nail-designs/:id',
      component: () => import('@/pages/ClientApp/NailDesigns/Item'),
      name: 'client-app_nail-design-item',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.NAIL_DESIGNS,
      },
    },
    {
      path: '/client-app-news',
      component: () => import('@/pages/ClientApp/News/List'),
      name: 'client-app_news',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.NEWS,
      },
    },
    {
      path: '/bonus-wheel',
      component: () => import('@/pages/ClientApp/BonusWheel/List'),
      name: 'bonus-wheel',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.NEWS,
      },
    },
    {
      path: '/bonus-wheel/:id',
      component: () => import('@/pages/ClientApp/BonusWheel/Item'),
      name: 'bonus-wheel-item',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.NEWS,
      },
    },
    {
      path: '/surveys',
      component: () => import('@/pages/Surveys/List'),
      name: 'surveys',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.SURVEY.view,
      },
    },
    {
      path: '/surveys/:id',
      component: () => import('@/pages/Surveys/Item'),
      name: 'surveys-item',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.NEWS,
      },
    },
    {
      path: '/master-app_teach',
      component: () => import('@/pages/MasterApp/Teach/List'),
      name: 'master-app_teach',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.NEWS,
      },
    },
    {
      path: '/master-app_teach_create/:id',
      component: () => import('@/pages/MasterApp/Teach/CreateTeach.vue'),
      name: 'master-app_teach_create',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.NEWS,
      },
    },
    {
      path: '/master-contest-item/:id',
      component: () => import('@/pages/MasterApp/Contest/Item.vue'),
      name: 'master-contest-item',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.NEWS,
      },
    },
    {
      path: '/master-contest',
      component: () => import('@/pages/MasterApp/Contest/List.vue'),
      name: 'master-contest',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.NEWS,
      },
    },
    {
      path: '/client-app-news/:id',
      component: () => import('@/pages/ClientApp/News/Item'),
      name: 'client-app_news-item',
      beforeEnter: checkRules,
      meta: {
        permission: Vue.config.permissions.PERMISSIONS_CONSTANTS.NEWS,
      },
    },
  ],
  mode: 'history',
  saveScrollPosition: true,
})
